import CallbackPage from "join-form/pages/business/callback";

function BusinessCallbackTemplate(props) {
  return <CallbackPage {...props} />;
}

export { BusinessCallbackTemplate };
